import React from "react";
import "../../../../css/Turismo/turismo.css";

const EstacionTrenes = () => (
  <div>
    <div
      style={{
        backgroundImage: `url(${require("../../../img/Estacion-de-Trenes.jpeg")})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: 450,
        marginBottom: 30,
      }}
    />
    <div className="container">
      <h1 className="text-center"><strong>ESTACIÓN DE TRENES</strong></h1>
      <br />
      <div className="text-center">
        <img
          src={require("../../../img/destacados/horarios-tren.png")}
          alt="Horarios de tren"
          style={{ maxWidth: "100%", height: "auto" }}
        />
      </div>
      <div className="text-center" style={{ margin: "30px 0" }}>
        <a href="/turismo" className="btn btn-primary">Volver a Turismo</a>
      </div>
    </div>
  </div>
);

export default EstacionTrenes;
